import { Component, inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { NGXLogger } from 'ngx-logger';
import { Observable, of, Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { SchoolMemberType } from '../../../models/member.school.model';
import { MembershipStatus } from '../../../models/membership.status';
import { SchoolRoles } from '../../../models/roles.school.model';
import { AlbumService } from '../../../services/album.service';
import { SchoolRolesService } from '../../../services/school-roles.service';
import { UtilsService } from '../../../services/utils.service';
import { AppState } from '../../../state/appstate';
import { BtnActionComponent } from '../../components/buttons/btn-action/btn-action.component';
import { AlertType } from '../../components/dialogs/dlg-confirm/dlg-confirm.component';
import { S3ImagesUploadComponent } from '../../components/uploaders/s3-images-upload/s3-images-upload.component';

@Component({
  selector: 'dlg-add-images',
  standalone: true,
  imports: [BtnActionComponent, S3ImagesUploadComponent],
  templateUrl: './dlg-add-images.component.html',
  styleUrl: './dlg-add-images.component.css',
})
export class DlgAddImagesComponent implements OnInit, OnDestroy {
  roles: SchoolRolesService = inject(SchoolRolesService);
  private store: Store<AppState> = inject(Store<AppState>);
  private utilsService: UtilsService = inject(UtilsService);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  @ViewChild('imageUploader') uploader!: S3ImagesUploadComponent;

  preSignedUrlEndpoint: string = environment.AWS_ALBUM_IMAGE_SIGNEDURL;
  apiKey: string = environment.AWS_ALBUMS_API_KEY;

  logger: NGXLogger = inject(NGXLogger);
  private dialog: MatDialog = inject(MatDialog);
  albumService: AlbumService = inject(AlbumService);

  groupId: string;
  albumId: string;

  working$: Observable<boolean> = of(false);

  metadata: any = {};
  filePath: string = '';

  membershipStatus = MembershipStatus;
  memberType = SchoolMemberType;
  rolesType = SchoolRoles;

  exit$ = new Subject<void>();

  constructor() {
    this.groupId = this.data.groupId;
    this.albumId = this.data.albumId;
  }

  ngOnInit(): void {
    document.body.style.overflow = 'hidden';
    this.filePath = `groups/${this.groupId}/albums/${this.albumId}/images`;
    this.metadata = {
      groupId: this.groupId,
      albumId: this.albumId,
    };
  }

  ngOnDestroy(): void {
    document.body.style.overflow = 'auto';
    this.exit$.next();
    this.exit$.complete();
  }

  onCancel(): void {
    this.dialog.closeAll();
  }

  onAddImages(): void {
    this.logger.debug('Add images to album', this.albumId);
    this.working$ = of(true);
    this.uploader
      .upload()
      .then((result) => {
        this.logger.debug(`Upload result: ${JSON.stringify(result, null, 2)}`);

        this.working$ = of(true);
        if (result?.successful && result.successful[0]?.response?.uploadURL) {
          this.utilsService.onShowConfirmation({
            title: 'Image(s) Uploaded',
            description:
              'The images have been uploaded successfully. Kindly wait for Image processing to complete.',
            action: 'Okay',
            alertType: AlertType.success,
          });
        } else {
          this.utilsService.onShowAlert(
            {
              code: 'ERR_UPLOAD_IMAGES',
              message: 'Failed to upload images. Please try again later',
              title: 'Error Uploading Images',
            },
            false,
          );
        }
      })
      .catch((error) => {
        this.utilsService.onShowAlert(
          {
            code: 'ERR_UPLOAD_IMAGES',
            message: 'Failed to upload images. Please try again later',
            title: 'Error Uploading images',
          },
          false,
        );
      });
  }
}
